<div class="avatar-container" [ngStyle]="hostStyle">

    @if(showUserIcon()) {
        <div class="generic-avatar-content user-icon-avatar"
            [style.width.px]="size()"
            [style.height.px]="size()">
            <mat-icon svgIcon="user" aria-hidden="true"></mat-icon>
        </div>
    } @else if(showGenericAvatar) {
        <div class="generic-avatar-content header-reg-l" 
            [style.width.px]="size()" 
            [style.height.px]="size()">
            {{ initialsLettersAvatarText }}
        </div>
    } @else {
        <div class="avatar-content" [ngStyle]="avatarStyle">
            {{ avatarText }}
        </div>
    }

</div>
